export const mapFormToRelationType = values => ({
  ...values,
  sourceRestrictions: (values?.sourceRestrictions || []).map(sr => ({ organisationRoleId: sr })),
  targetRestrictions: (values?.targetRestrictions || []).map(tr => ({ organisationRoleId: tr })),
});
